import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import PaypalRadio from 'components/FrictionlessCheckout/Payment/PaymentMethodList/PaypalRadio/PaypalRadio';
import PaymentSectionEN from 'components/FrictionlessCheckout/Payment/locales/Payment_en_US';
import PaymentSectionFR from 'components/FrictionlessCheckout/Payment/locales/Payment_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(PaymentSectionEN, PaymentSectionFR);

const textResources = createStructuredSelector({
    editPaypal: getTextFromResource(getText, 'editPaypal')
});

const connectedPlaceOrderButton = connect(
    createSelector(textResources, texts => {
        return texts;
    })
);

const withPlaceOrderButtonProps = wrapHOC(connectedPlaceOrderButton);

export default withPlaceOrderButtonProps(PaypalRadio);
